import { render, staticRenderFns } from "./CollectiveLogo.vue?vue&type=template&id=a25722e8&scoped=true"
import script from "./CollectiveLogo.vue?vue&type=script&lang=js"
export * from "./CollectiveLogo.vue?vue&type=script&lang=js"
import style0 from "./CollectiveLogo.vue?vue&type=style&index=0&id=a25722e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25722e8",
  null
  
)

export default component.exports